import React, { useContext } from 'react';
import Form, { FormProps } from '../../..';
import TabInvoice from './TabFormInvoiceUpdate';
import Tabs from '../../../../Tabs';
import * as S from '../styled';
import { ExportContext } from '../../../../../provider/ExportProvider';
import {
  defaultBlurInvoiceForm,
  defaultInvoiceForm,
} from '../../../../../store/invoice/utils';
import TabFormInvoiceTaxUpdate from './TabFormInvoiceTaxUpdate';
import { useSnackbar } from 'notistack';

export default function FormInvoiceUpdate() {
  const {
    invoices,
    getInvoice,
    setInvoice,
    updateInvoice,
    setModal,
    validateForm,
    filterInvoice,
  } = useContext(ExportContext)!.controllers.invoice;
  const { enqueueSnackbar } = useSnackbar();

  const clearForm = () => {
    const invoice = invoices.find(
      ({ id }) => getInvoice('forms.invoices.update').id === id,
    )!;
    setInvoice(`forms.invoices.update`, {
      id: invoice.id,
      product: invoice.product,
      date: invoice.date,
      crt: invoice.crt,
      invoiceNumber: invoice.invoiceNumber,
      invoiceValue: invoice.invoiceValue,
      invoiceQuantity: invoice.invoiceQuantity,
      unitCostReal: invoice.unitCostReal,
      realValue: invoice.realValue,
      status: invoice.status,
      totalCost: invoice.totalCost,
      unitCostTotal: invoice.unitCostTotal,
      unitSale: invoice.unitSale,
      unitProfit: invoice.unitProfit,
      totalProfit: invoice.totalProfit,
      company: invoice.company,
      invoiceTaxes: invoice.invoiceTaxes,
      observation: invoice.observation ?? '',
      locked: invoice.locked,
      labeled: invoice.labeled ?? false,
      group: {
        id: invoice.group?.id ?? 0,
        number: invoice.group?.number ?? 0,
        name: invoice.group?.name ?? '',
      }
    });
    setInvoice(`blur.invoices.update`, defaultBlurInvoiceForm());
  };

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('invoices.update')
      .then(() => {
        setLoading(true);
        updateInvoice()
          .then((invoice) => {
            enqueueSnackbar('Invoice atualizada com sucesso', {
              variant: 'success',
            });
            setInvoice('forms.invoices.update', {
              id: 0,
              ...defaultInvoiceForm(),
            });
            setInvoice(`blur.invoices.update`, defaultBlurInvoiceForm());
            setModal('single.updateInvoice', false);
            setInvoice(
              'filters.invoices.data.data',
              getInvoice('filters.invoices.data.data').map((inv) =>
                invoice.id === inv.id ? invoice : inv,
              ),
            );
            filterInvoice();
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao atualizar a invoice', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };
  const locked = getInvoice('forms.invoices.update.locked');
  return (
    <S.Form onSubmit={onSubmit}>
      <Tabs
        minHeight={'60vh'}
        maxHeight={'60vh'}
        style={{
          margin: '0 20px',
        }}
        items={[
          {
            label: 'INVOICE',
            children: <TabInvoice />,
          },
          {
            label: 'TAXAS',
            children: <TabFormInvoiceTaxUpdate />,
          },
        ]}
      />
      <S.Actions>
        <Form.Button type="button" disabled={locked} onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading} disabled={locked}>
          Atualizar
        </Form.Button>
      </S.Actions>
    </S.Form>
  );
}
